// This is an auto-generated file. Do not edit it directly — your changes will be overwritten the next time the model configs are generated.

 import type { IntegrationUserAgent } from '@pigello/pigello-matrix';


import { useGetInstance, useGetList } from '@/requests/hooks';

import type {
  useGetGenericInstanceProps,
  useGetGenericListProps,
} from '@/requests/types';


export const useGetIntegrationUserAgent = (
  options: useGetGenericInstanceProps<IntegrationUserAgent>
) => {
  return useGetInstance<IntegrationUserAgent>({
    ...options,
    modelName: 'integrationuseragent'
  });
};

export const useGetIntegrationUserAgentList = (
  options: useGetGenericListProps<IntegrationUserAgent>
) => {
  return useGetList<IntegrationUserAgent>({
    ...options,
    modelName: 'integrationuseragent'
  });
};
